import { Hero } from "@/components/hero/Hero";
import { Marquee } from "@/components/home/Marquee";
import { ResidencesSection } from "@/components/home/ResidencesSection";
import { RoamPromise } from "@/components/home/Promise";
import { Ascent } from "@/components/home/Ascent";
import { NeighbourhoodsGallery } from "@/components/home/NeighbourhoodsGallery";
import { Proof } from "@/components/home/Proof";
import { ClosingCta } from "@/components/home/ClosingCta";
import { RelocatingBand } from "@/components/home/RelocatingBand";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <Marquee />
      <ResidencesSection />
      <RoamPromise />
      <Ascent />
      <NeighbourhoodsGallery />
      <Proof />
      <ClosingCta />
      <RelocatingBand />
    </div>
  );
}
